import React from "react";
import "../../ProvidersRRDetails/style.css";
import Details from "./Components/RequestData/index";
import ProviderDetailsSkeleton from "./Components/ProviderDetailsSkeleton";
import { CRRender } from "@/component/crRender";

const ProfileData = ({ requestDetails, isPending }) => {
    console.log(isPending);
    return (
        <>
            <ProviderDetailsSkeleton isRender={!!isPending} />
            <CRRender isRender={!isPending}>
                <Details requestDetails={requestDetails} />
            </CRRender>
        </>
    );
}

export default ProfileData